




























import { defineComponent, PropType, computed } from '@vue/composition-api';
import { Year, Month } from '@oare/types';
import PeriodMonth from './PeriodMonth.vue';

export default defineComponent({
  name: 'PeriodYear',
  components: { PeriodMonth },
  props: {
    year: {
      type: Object as PropType<Year>,
      required: true,
    },
  },

  setup(props) {
    const standardMonths = computed(() =>
      props.year.months.filter(month => month.abbreviation < 13)
    );
    const intercalaryMonth = computed(() =>
      props.year.months.find(month => month.abbreviation > 12)
    );
    return {
      standardMonths,
      intercalaryMonth,
    };
  },
});
